import React , { Component } from 'react';
import LoggedInPage from '../../../views/core/LoggedInPage';

class InfoDetail extends LoggedInPage{
    constructor(props){
        super(props);

        this.data = (this.props.data) ? this.props.data : {wrongQuestionCount:0, unAttemptedQuestionCount:0, totalQuestionCount:0, correctQuestionCount:0, topicName: ""};

        this.state = {			
	};

    }
    componentDidMount (){
         super.componentDidMount();
    }

getUnattemptedAndWrong(){
    return (this.props.data.wrongQuestionCount || 0) + (this.props.data.unAttemptedQuestionCount || 0);

}

renderInfoDetail(){
        return(
            <div id="ques-info" className="row">
                <div className="info-container">
                    <div className="col-md-6 left-content">
                        
                        <div className="topicDetails">
                            <div>{this.rb("view.solution.topic")}</div>
                            <div className="topicName">{this.props.data.topicName}</div>
                        </div>
                            
                    </div>
                    <div className="col-md-6 right-content">
                        <div className="testInfo">
                            <div className="row">
                                <div className="col-md-12 col-12 caption">{this.rb("view.solution.questions")}
                                <span className="count-value">{this.props.data.totalQuestionCount}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 col-6 caption correct"><i className="material-icons">check_circle</i>{this.rb("view.solution.correct")}<span className="count-value">{this.props.data.correctQuestionCount}</span></div>
                                <div className="col-md-6 col-6 caption wrong"><i className="material-icons">cancel</i>{this.rb("view.solution.wrong")}<span className="count-value">{this.getUnattemptedAndWrong()}</span></div>
                            </div>
                        </div>						
                    </div>					
                </div>
            </div>
        )    
}
render = () => {
  return(				
            <div>
            {this.renderInfoDetail()}
            </div>
    );
}
}

export default InfoDetail;



// WEBPACK FOOTER //
// ./src/views/contest/viewsolution/InfoDetail.js